var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2869",
    "data-name": "Group 2869",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.656,
    height: 19.656,
    viewBox: "0 0 19.656 19.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M0,0H19.656V19.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M4.836,3.993A8.191,8.191,0,0,1,16.9,14.891l-2.613-4.7h2.457A6.552,6.552,0,0,0,5.653,5.463Zm10.708,12.4A8.191,8.191,0,0,1,3.482,5.489L6.1,10.19H3.638a6.552,6.552,0,0,0,11.089,4.727Z",
    transform: "translate(-0.362 -0.362)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionYellow);
export default __webpack_public_path__ + "static/media/transaction-yellow.6797be0a0b20c0c4acaf94824400bae6.svg";
export { ForwardRef as ReactComponent };